import React from 'react';
import './Formbox.css';


const Formbox = ({ elements }) => {
    return (
		<div className="form-v1-content">
			<div className="wizard-form">
                {elements}

            </div>
        </div>
    );
};

export default Formbox;
